// extracted by mini-css-extract-plugin
module.exports = {"mobile-grid__row":"styles_mobile-grid__row__7AiyQ","mobile-grid__image-card":"styles_mobile-grid__image-card__GFxJ7","shimmer":"styles_shimmer__D6Qrf"};